// Normalize axios/FastAPI errors into a readable string.
// FastAPI 422 returns detail as an array of {type,loc,msg,...} objects — React can't render objects.
export function errMsg(e, fallback = "Something went wrong") {
  const d = e?.response?.data?.detail;
  if (Array.isArray(d)) return d.map((x) => x.msg || x.type || JSON.stringify(x)).join(", ");
  if (typeof d === "string") return d;
  if (typeof d === "object" && d) return d.msg || JSON.stringify(d);
  return e?.message || fallback;
}
